import createEmployeFormModel from './editarEmployeFormModel';
const {
  formField: {
    // DATOS CLIENTE
    e_document_type,
    e_document_number,
    e_file_img_upload,
    e_expedition_place,
    e_name,
    e_last_name,
    e_date_of_birth,
    e_gender,
    e_civil_status,
    e_landline,
    e_cell_phone,
    e_corporate_cell_phone,
    e_whatsapp,
    e_rh,
    e_dominance,
    e_allergies,
    e_cedula,
    e_housing_type,
    e_neighborhood,
    e_stratum,
    e_cost_center,
    e_compani,
    e_work_headquarters,
    e_cargo,
    e_cv,
    e_scholarship,
    e_institution,
    e_degree,
    e_address,
    e_email,

    // LABORAL
    e_type_contract,
    e_salary_base,
    e_transport_subsidy,
    e_payment_method,
    e_frecuency_payment,
    e_associated_bank,
    e_certificate_banck_name_saved_name,
    e_account_number,
    e_certificate_bank,
    e_date_start_contract,
    e_vacation_acumulate,
    e_bonification_aditional,
    e_lunes,
    e_martes,
    e_miercoles,
    e_jueves,
    e_viernes,
    e_sabado,
    e_domingo,
    e_festivo,
    e_dayrest,
    // FAMILIA
    e_numOfBeneficiary,
    // family,
    // SEGURIDAD SOCIAL
    e_eps,
    e_familyCompensation,
    e_fileCajaCompensacion,
    e_caja_compensacion_name_saved,
    e_cesantias,
    e_fileCesantias,
    e_cesantias_name_saved,
    e_pension,
    e_fileArl,
    // DOTACION
    // items_uno,
    // talla_uno,
    // cantidad_uno,
    // color_uno,
    // item_descripcion_uno,
    // items2,
    // talla2,
    // cantidad2,
    // color2,
    // item_descripcion2,
    // items3,
    // talla3,
    // cantidad3,
    // color3,
    // item_descripcion3,
    // items4,
    // talla4,
    // cantidad4,
    // color4,
    // item_descripcion4,
    // items5,
    // talla5,
    // cantidad5,
    // color5,
    // item_descripcion5,
    // PRUEBAS INGRESO
    e_vista_domiciliaria,
    e_fileVisitaDomiciliaria,
    e_visita_domiciliaria_name_saved,
    e_prueba_psicotecnica,
    e_filePsicotecnica,
    e_psicotecnica_name_saved,
    e_manipulacion_alimentos,
    e_fileManipulacionAlimentos,
    e_manipulacion_alimentos_name_saved,
    e_trabajo_alturas,
    e_fileTrabajoAlturas,
    e_trabajo_altura_name_saved,
    e_fileExamenMedico,
    e_examen_medico,
    e_examen_medico_name_saved,
    e_contrato,
    e_certificado_estudios,
    e_fileCertificadoEstudios,
    e_certificado_estudios_name_saved,
    e_certificado_laboral,
    e_fileCertificadoLaboral,
    e_certificado_laboral_name_saved,
    e_verificacion_adres,
    e_fileVerificacionAdres,
    e_verificacion_adres_name_saved,
    e_antecedentes,
    e_fileAntecedentes,
    e_antecedentes_name_saved,
    e_entrevista,
    e_fileEntrevista,
    e_entrevista_name_saved,
    e_sociodemografica,
    e_fileSociodemografica,
    e_sociodemografica_name_saved,
    e_compromiso_sst,
    e_fileCompromisoSst,
    e_compromiso_sst_name_saved,
  },
} = createEmployeFormModel;

export default {
  [e_document_type.name]: '',
  [e_document_number.name]: '',
  [e_file_img_upload.name]: null,
  [e_expedition_place.name]: '',
  [e_name.name]: '',
  [e_last_name.name]: '',
  [e_date_of_birth.name]: null,
  [e_gender.name]: null,
  [e_civil_status.name]: null,
  [e_landline.name]: '',
  [e_cell_phone.name]: '',
  [e_corporate_cell_phone.name]: '',
  [e_whatsapp.name]: false,
  [e_rh.name]: '',
  [e_dominance.name]: '',
  [e_allergies.name]: '',
  [e_cedula.name]: null,
  [e_housing_type.name]: null,
  [e_neighborhood.name]: '',
  [e_stratum.name]: '',
  [e_cost_center.name]: null,
  [e_compani.name]: '',
  [e_work_headquarters.name]: null,
  [e_cargo.name]: null,
  [e_cv.name]: null,
  [e_scholarship.name]: null,
  [e_institution.name]: '',
  [e_degree.name]: '',
  [e_address.name]: '',
  [e_email.name]: '',

  // LABORAL
  [e_type_contract.name]: '',
  [e_salary_base.name]: '',
  [e_transport_subsidy.name]: false,
  [e_payment_method.name]: '',
  [e_frecuency_payment.name]: '',
  [e_associated_bank.name]: '',
  [e_certificate_banck_name_saved_name.name]: '',
  [e_account_number.name]: '',
  [e_certificate_bank.name]: null,
  [e_vacation_acumulate.name]: '',
  [e_bonification_aditional.name]: '',
  [e_date_start_contract.name]: null,
  [e_lunes.name]: false,
  [e_martes.name]: false,
  [e_miercoles.name]: false,
  [e_jueves.name]: false,
  [e_viernes.name]: false,
  [e_sabado.name]: false,
  [e_domingo.name]: false,
  [e_festivo.name]: false,
  [e_dayrest.name]: '',

  // FAMILIA
  [e_numOfBeneficiary.name]: 0,
  // [e_family.name]: '',

  // SEGURIDAD SOCIAL
  [e_eps.name]: null,
  [e_familyCompensation.name]: null,
  [e_fileCajaCompensacion.name]: null,
  [e_caja_compensacion_name_saved.name]: null,
  [e_cesantias.name]: null,
  [e_cesantias_name_saved.name]: null,
  [e_fileCesantias.name]: null,
  [e_pension.name]: null,
  [e_fileArl.name]: null,
  // DOTACION
  // [e_items_uno.name]: null,
  // [e_talla_uno.name]: '',
  // [e_cantidad_uno.name]: '',
  // [e_color_uno.name]: '',
  // [e_item_descripcion_uno.name]: '',
  // [e_items2.name]: null,
  // [e_talla2.name]: '',
  // [e_cantidad2.name]: '',
  // [e_color2.name]: '',
  // [e_item_descripcion2.name]: '',
  // [e_items3.name]: null,
  // [e_talla3.name]: '',
  // [e_cantidad3.name]: '',
  // [e_color3.name]: '',
  // [e_item_descripcion3.name]: '',
  // [e_items4.name]: null,
  // [e_talla4.name]: '',
  // [e_cantidad4.name]: '',
  // [e_color4.name]: '',
  // [e_item_descripcion4.name]: '',
  // [e_items5.name]: null,
  // [e_talla5.name]: '',
  // [e_cantidad5.name]: '',
  // [e_color5.name]: '',
  // [e_item_descripcion5.name]: '',
  // PRUEBAS INGRESO
  [e_vista_domiciliaria.name]: false,
  [e_fileVisitaDomiciliaria.name]: null,
  [e_visita_domiciliaria_name_saved.name]: '',
  // VISITA DOMICILIARIA
  [e_prueba_psicotecnica.name]: false,
  [e_filePsicotecnica.name]: null,
  [e_psicotecnica_name_saved.name]: '',
  // MANIPULACION ALIMENTOS
  [e_manipulacion_alimentos.name]: false,
  [e_fileManipulacionAlimentos.name]: null,
  [e_manipulacion_alimentos_name_saved.name]: '',
  // TRABAJO EN ALTURAS
  [e_trabajo_alturas.name]: false,
  [e_fileTrabajoAlturas.name]: null,
  [e_trabajo_altura_name_saved.name]: '',
  // EXAMEN MEDICO
  [e_examen_medico.name]: false,
  [e_fileExamenMedico.name]: null,
  [e_examen_medico_name_saved.name]: '',
  // CONTRATO
  [e_contrato.name]: false,
  // CERTIFICADO ESTUDIOS
  [e_certificado_estudios.name]: false,
  [e_fileCertificadoEstudios.name]: null,
  [e_certificado_estudios_name_saved.name]: '',
  // CERTIFICADO LABORAL
  [e_certificado_laboral.name]: false,
  [e_fileCertificadoLaboral.name]: null,
  [e_certificado_laboral_name_saved.name]: '',
  // VERIFICACION ADRES
  [e_verificacion_adres.name]: false,
  [e_fileVerificacionAdres.name]: null,
  [e_verificacion_adres_name_saved.name]: '',
  // ANTECEDENTES
  [e_antecedentes.name]: false,
  [e_fileAntecedentes.name]: null,
  [e_antecedentes_name_saved.name]: '',
  // ENTREVISTA
  [e_entrevista.name]: false,
  [e_fileEntrevista.name]: null,
  [e_entrevista_name_saved.name]: '',
  // ENTREVISTA SOCIODEMOGRAFICA
  [e_sociodemografica.name]: false,
  [e_fileSociodemografica.name]: null,
  [e_sociodemografica_name_saved.name]: '',
  // COMPROMISO SST
  [e_compromiso_sst.name]: false,
  [e_fileCompromisoSst.name]: null,
  [e_compromiso_sst_name_saved.name]: '',
};
